import { IStaff } from "../../types/types";
import { clipText, CompactTableColumn } from "./compactTableColumn";

export const STAFF_TABLE_COLUMNS: CompactTableColumn<IStaff>[] = [
  { id: "name", header: "Nimi", sortKey: "name", width: "22%", render: (s) => s.name },
  { id: "handle", header: "Nimimerkki", sortKey: "handle", width: "22%", render: (s) => s.handle },
  { id: "role", header: "Rooli", sortKey: "role", width: "16%", render: (s) => s.role },
  {
    id: "link",
    header: "Linkki",
    sortKey: "link",
    width: "40%",
    render: (s) => clipText(s.link, 48),
  },
];
